/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type {
  TelegramProductsControllerFindSimilarQueryResponse,
  TelegramProductsControllerFindSimilarPathParams,
  TelegramProductsControllerFindSimilar401,
} from '../types/TelegramProductsControllerFindSimilar.ts';

function getTelegramProductsFindSimilarUrl(id: TelegramProductsControllerFindSimilarPathParams['id']) {
  const res = { method: 'GET', url: `/api/telegram/products/similar/${id}` as const };
  return res;
}

/**
 * {@link /api/telegram/products/similar/:id}
 */
export async function telegramProductsFindSimilar(
  id: TelegramProductsControllerFindSimilarPathParams['id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    TelegramProductsControllerFindSimilarQueryResponse,
    ResponseErrorConfig<TelegramProductsControllerFindSimilar401>,
    unknown
  >({ method: 'GET', url: getTelegramProductsFindSimilarUrl(id).url.toString(), ...requestConfig });
  return res.data;
}
